var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58321 0H5.41661C5.18762 0 5 0.187615 5 0.416611V2.91652C5 3.14564 5.18762 3.33325 5.41661 3.33325H9.58321C9.8122 3.33325 9.99982 3.14564 9.99982 2.91652V0.416611C9.99982 0.187615 9.8122 0 9.58321 0Z",
    fill: "#F7F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58321 6.66644H0.416611C0.187615 6.66644 0 6.85406 0 7.08318V9.58308C0 9.81208 0.187615 9.99969 0.416611 9.99969H4.58321C4.8122 9.99969 4.99982 9.81208 4.99982 9.58308V7.08318C4.99982 6.85406 4.8122 6.66644 4.58321 6.66644Z",
    fill: "#F7F7F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91701 2.0833H4.16647V1.24995H2.91701C1.99668 1.24995 1.24995 1.9958 1.24995 2.91615V4.4106L0.589236 3.75025L0 4.33947L1.37207 5.71105C1.53444 5.87378 1.79842 5.87378 1.96131 5.71105L3.33337 4.33898L2.74402 3.74986L2.0833 4.41058L2.08366 2.91613C2.08366 2.45592 2.45679 2.0833 2.91701 2.0833Z",
    fill: "#F7F7F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6279 4.28859C8.46553 4.12585 8.20155 4.12585 8.03866 4.28859L6.66672 5.66053L7.25595 6.24977L7.91667 5.58905L7.91631 7.0835C7.91631 7.54374 7.5432 7.91636 7.08296 7.91636H5.8335V8.74968H7.08296C8.00331 8.74968 8.75002 8.00383 8.75002 7.08348V5.58903L9.41073 6.24938L9.99997 5.66014L8.6279 4.28859Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateIcon);
export default __webpack_public_path__ + "static/media/update-icon.7920a33aa05a2b11bf7a8b7188fdcc92.svg";
export { ForwardRef as ReactComponent };